import * as React from 'react';
import * as styles from './revisions.module.scss';
import Scrollbars from 'react-custom-scrollbars';
import RevisionRow from './revision-row';
import Revision from '../../../models/revision';
import { PaginatedRevisionsContext } from '../../../shared/paginated-revisions';
import Table from '../../table/table';
import TableHead from '../../table/table-head';
import TableBody from '../../table/table-body';
import HeaderCell from '../../table/table-header-cell';

interface Props {
  clientId: number;
  loading: boolean;
  isGlobal: boolean;
  setErrorMessage: (message: string) => void;
  setSuccessMessage: (message: string) => void;
}

/**
 * Table that contains all revisions for an individual help document
 */
const RevisionsTable = ({ clientId, loading, isGlobal, setErrorMessage, setSuccessMessage }: Props) => {
  const { results } = React.useContext(PaginatedRevisionsContext);

  return (
    <div className={styles.tableWrapper}>
      <div style={{ height: '90%' }}>
        <Scrollbars className={styles.scrollTable} autoHide={true} universal={true}>
          <Table loading={loading} results={results}>
            <TableHead>
              <HeaderCell title="Revision #" scope="col" />
              <HeaderCell title="Modified By" scope="col" />
              <HeaderCell title="Modified Date" scope="col" />
              <HeaderCell title="" />
              <HeaderCell title="" />
            </TableHead>
            <TableBody>
              {!results || results.length === 0 ? (
                <tr>
                  <td>There are no revisions.</td>
                </tr>
              ) : (
                results.map((result: Revision, index: number) => {
                  return (
                    <RevisionRow
                      key={result.snippetId}
                      clientId={clientId}
                      revision={result}
                      isGlobal={isGlobal}
                      setErrorMessage={setErrorMessage}
                      setSuccessMessage={setSuccessMessage}
                    />
                  );
                })
              )}
            </TableBody>
          </Table>
        </Scrollbars>
      </div>
    </div>
  );
};

export default RevisionsTable;
